import i18next from 'config/i18n';

const runTranslate = () => ({
  emailRules: [
    {
      type: 'email',
      message: i18next.t('auth.rules.validEmail')
    },
    {
      required: true,
      message: i18next.t('auth.rules.emptyEmail')
    }
  ],
});

i18next.on('languageChanged', () => runTranslate());

export default runTranslate;
